// extracted by mini-css-extract-plugin
export default {"eyeContainer":"eye_eyeContainer__veiFh","eye":"eye_eye__vdM5P"};